import { createFetchedDataRecord, updateObject } from '@vista-digital/utilities';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
export const loadAllSites = async () => {
    await loadDataFromApi({
        api: ocapiClient.instance.v1.browsing.masterData.sites.getAll,
        state: browsingDomainStore.data.allSiteIds,
        cacheDuration: getCacheDuration('sites'),
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const { sites } = response;
    updateObject(browsingDomainStore.data.sitesById, createFetchedDataRecord(sites, 'id', cacheDuration));
    return sites.map(site => site.id);
};
//# sourceMappingURL=load-all-sites.js.map